
<div class="eye-view-details">
  @if(orderDetails){
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Freight Payer
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.freightPayer}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Delivery Status
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.deliveryStatus}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Account
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.account}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Order #
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderNumber }}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Consignment Note
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.consignmentNote}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Requested Delivery
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.requestedDelivery | date: 'dd/MM/yyyy'}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Temperature Type
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.temperatureType}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Temperature
      </div>
      <div class="col-8 eye-view-details-content">
        @if(orderDetails.temperature){
          {{ orderDetails.temperature + " (°C)"}}
        }
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Units
      </div>
      <div class="col-8 eye-view-details-content">
        <div class="row">
          <div class="col-8">
            {{ unitsSum }}
          </div>
          <div class="col-4 text-end">
            <button (click)="openProductDetailModal()" class="btn btn-xsm">Show</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end eye-view-details-header">
        Weight (kgs)
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.weightKg | number: '1.2-2'}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end text-end eye-view-details-header">
        Volume (m3)
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.volumeM3 | number: '1.2-2'}}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end eye-view-details-header">
        Is Export Order
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.isExportOrder ? "Yes" : "No" }}
      </div>
    </div>
    <div class="row eye-view-details-row">
      <div class="col-4 mogo-bold text-end eye-view-details-header">
        Export Certificate No.
      </div>
      <div class="col-8 eye-view-details-content">
        {{ orderDetails.exportCertificateNumber }}
      </div>
    </div>
  }
</div>
